
import { Component, mixins } from '@niknevis/vue-modules'
import { TesTableBottom } from '@/modules/common/tes-table/components/shared/base/TesTableBottom'
import { TesTablePagination } from '@/modules/common/tes-table/components/shared/base/TesTablePagination'
import { TesTableGrid } from '@/modules/common/tes-table/components/shared/base/TesTableGrid'
import { TesTableBase } from '@/modules/common/tes-table/components/shared/base/TesTableBase'
import { TesTableBody } from '@/modules/common/tes-table/components/shared/base/TesTableBody'
import { Prop } from 'vue-property-decorator'

@Component
export default class TesTable extends mixins<TesTableBase>(
  TesTableBase,
  TesTableBottom,
  TesTablePagination,
  TesTableGrid,
  TesTableBody
) {
  @Prop({ default: undefined }) readonly tesGrid: boolean
  @Prop({ default: undefined }) readonly tesHideHeader: boolean

  get grid() {
    return this.tesGrid ?? this.$q.screen.lt.md
  }

  get hideHeader() {
    return this.tesHideHeader ?? this.$q.screen.lt.md
  }

  render(h) {
    const child = [this.__getTopDiv(h)]
    const data = { staticClass: 'tes-table ' + this.containerClass }

    if (this.grid === true) {
      child.push(this.__getGridHeader(h))
    } else {
      Object.assign(data, {
        class: this.cardClass,
        style: this.cardStyle
      })
    }

    child.push(
      this.__getBody(h),
      this.__getBottomDiv(h)
    )

    if (this.loading === true && this.$scopedSlots.loading !== void 0) {
      child.push(
        this.$scopedSlots.loading({})
      )
    }

    return h('div', data, child)
  }

}
